module.exports = __webpack_public_path__ + "img/元素2@3x.425cedd.425cedde.png";